import { apiClient } from './api-client';

export async function getJsxQwanta(_id, di) {
    try {
        // Use API client to get the document - same as before
        const result = await apiClient.get(`/api/qwanyx/sync/${_id}`);
        
        if (!result) {
            throw new Error(`Document not found: ${_id}`);
        }

        // Extract the jsxqwanta from the result - EXACTLY as before
        const jsxqwanta = result.jsxqwanta;
        
        //console.log("Final flattenedJsxQwanta:", jsxqwanta);
      
        return jsxqwanta; 
    } catch (error) {
        console.error("Error fetching jsxQwanta from Qwantas:", error);
        throw error;
    }
}